module.exports = __webpack_public_path__ + "img/menu.d84fc800.svg";